import React from 'react';
import { compose, withStateHandlers, withHandlers } from 'recompose';
import { get } from 'lodash';
import { Col, FormGroup, Label } from 'reactstrap';
import { LocalForm, Control } from 'react-redux-form';
import { NotificationManager } from 'react-notifications';
import SaveButton from 'components/common/Forms/SaveButton';
import Page from 'components/common/Page';
import { Auth } from 'services';
import { TECHNICIAN, CRUISE } from 'permissions';

export const Login = ({ item, setItem, form, onSubmit, setForm }) => {
  if (!item) return null;

  return (
    <Col xs={false} lg={6} className="mx-auto">
      <Page title="Login">
        <LocalForm
          initialState={item}
          onSubmit={onSubmit}
          onChange={setItem}
          onUpdate={setForm}
        >
          <FormGroup>
            <Label>Username</Label>
            <Control.text model=".username" required className="form-control" />
          </FormGroup>
          <FormGroup>
            <Label>Password</Label>
            <Control.text
              model=".password"
              type="password"
              required
              className="form-control"
            />
          </FormGroup>
          {form && (
            <SaveButton
              type="submit"
              form={form}
              className="float-right disabled-cursor-not-allowed"
            >
              Submit
            </SaveButton>
          )}
        </LocalForm>
      </Page>
    </Col>
  );
};

const enhance = compose(
  withStateHandlers(
    {
      item: { username: '', password: '' },
      form: null,
    },
    {
      setItem: () => item => ({ item }),
      setForm: () => form => ({ form }),
    }
  ),
  withHandlers({
    onSubmit: ({ item, history }) => () => {
      Auth.login(item)
        .tap(() => {
          if (Auth.getRole() === TECHNICIAN) {
            NotificationManager.error(
              'Technicians are not allowed to log in to the portal'
            );
            Auth.clearToken();
          } else if (Auth.getRole() === CRUISE) {
            NotificationManager.error(
              'Cruise service accounts are not allowed to log in to the portal'
            );
          } else {
            history.replace('/');
          }
        })
        .catch(err => {
          if (get(err, 'response.status') === 400) {
            NotificationManager.error('Invalid username or password');
          } else {
            NotificationManager.error('Unable to log in at this time');
          }
          err.handled = true;
          throw err;
        });
    },
  })
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/pages/Login.jsx